export const MEDIA_AUTHORS_CARD_REST_SHADOW_CLASS = 'shadow-media-authors-card';

export const MEDIA_AUTHORS_CARD_HOVER_SHADOW_CLASS =
  'transition-shadow hover:shadow-media-authors-card-hover';

export const MEDIA_AUTHORS_INTERACTIVE_CARD_SHADOW_CLASS = [
  MEDIA_AUTHORS_CARD_REST_SHADOW_CLASS,
  MEDIA_AUTHORS_CARD_HOVER_SHADOW_CLASS,
].join(' ');

export const MEDIA_AUTHORS_INTERACTIVE_CARD_LINK_CLASS = [
  MEDIA_AUTHORS_INTERACTIVE_CARD_SHADOW_CLASS,
  'group',
].join(' ');

export const MEDIA_AUTHORS_INTERACTIVE_CARD_TITLE_CLASS =
  'transition-colors group-hover:text-[#505CFF]';

export const MEDIA_AUTHORS_INTERACTIVE_MENTION_TITLE_CLASS = [
  'font-bold leading-[130%] text-[#1B1D22] underline decoration-[#C5C9D6] underline-offset-2 transition-colors',
  'group-hover:text-[#505CFF] group-hover:decoration-[#505CFF]',
].join(' ');
